// src/pages/SubmitDog.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SubmitDog = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  
  // Retrieve token and user info from localStorage (if logged in)
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;

  const handleDogSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (!user) {
      toast.error("Please log in to submit a dog post.");
      navigate('/login');
      return;
    }
    
    const formData = new FormData(e.target);
    const image_url = formData.get("image_url");
    const story = formData.get("story");
    const hashtags = formData.get("hashtags");
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/dogs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: user.id,
          image_url,
          story,
          hashtags,
        }),
      });
      
      if (response.ok) {
        await response.json();
        setSuccess("Dog post submitted successfully!");
        // Optionally, redirect to the feed after a delay
        setTimeout(() => navigate('/'), 1500);
      } else {
        const errData = await response.json();
        setError(errData.error || "Error submitting dog post");
      }
    } catch (err) {
      console.error("Error submitting dog post:", err);
      setError("Error submitting dog post");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Submit a Dog Post</h1>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {success && <p className="text-green-500 mb-4">{success}</p>}
      <form onSubmit={handleDogSubmit} className="bg-white p-6 shadow rounded">
        <div className="mb-4">
          <label className="block mb-1">Image URL:</label>
          <input
            name="image_url"
            type="url"
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1">Story:</label>
          <textarea
            name="story"
            className="w-full border p-2 rounded"
            maxLength="500"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1">Hashtags (comma-separated):</label>
          <input
            name="hashtags"
            type="text"
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
          Submit Dog Post
        </button>
      </form>
    </div>
  );
};

export default SubmitDog;
